// Module
var code = "<input ng-disabled=\"$ctrl.disabled\" type=\"checkbox\" class=\"form-control\" ng-model=\"$ctrl.ngModel\"/> <div class=\"slider round\"> </div> <span ng-if=\"$ctrl.error\" style=\"color:#a94442\">{{$ctrl.messageError}} </span> ";
// Exports
module.exports = code;